import { getOr } from 'lodash/fp';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EstimateTab from './EstimateTab';
import selectEstimate from '../../actions/selectEstimate';
import closeEstimate from '../../actions/closeEstimate';
import config from '../../helpers/config';

import countItems from './countItems';
import designPricing from '../../services/designPricing/design';
import getInstallationPricing from '../../helpers/installationPricing';

const mapStateToProps = ({ estimateBuilder: { entities, uiState, mandi } }, { designId }) => {
  const { estimates, containers, items } = entities;
  const design = estimates.byId[designId];

  const itemCount = countItems(items.byId, design);
  const isAutoReleaseDesign = getOr('false', 'attributes.isAutoReleaseDesign')(design);

  let price = isAutoReleaseDesign === 'true'
    ? designPricing(containers.byId, items.byId, 'retail', design)
    : designPricing(containers.byId, items.byId, 'subtotal', design);

  const isMandi = getOr(false, 'attributes.isMandi')(design) && config.estimatebuilderMode === 'mandi';
  if (isMandi) {
    const { charges } = getOr({}, `designs.${designId}.pricingResult`)(mandi);
    const { totalInstallationCost } = getInstallationPricing(charges);

    price += totalInstallationCost;
  }

  return {
    name: design.name,
    itemCount,
    price,
    isSelected: design.designId === uiState.selectedEstimate,
    id: design.designId,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ selectEstimate, closeEstimate }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EstimateTab);
